import React from "react";
import styles from "../../BorrowerDetails.module.css";
import { AiOutlineEye } from "react-icons/ai";
import { BiEdit } from "react-icons/bi";
import { useEffect, useState } from "react";
import { useBorrowerContext } from "../../store/borrower-details";
import ViewLoanDoc from "./ViewLoanDoc";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
const fieldsArr = [
  { field: "self_photo", setState: "selfPhoto" },
  { field: "loan_electricity_bill", setState: "electricityBill" },
  { field: "ration_card", setState: "rationCard" },
  { field: "loan_bank_statement", setState: "bankStatement" },
  { field: "loan_bank_report_documents", setState: "bankReport" },
  { field: "loan_signature_verification", setState: "signVerification" },
  { field: "bank_passbook_photo", setState: "bankPassbookPhoto" },
  { field: "loan_milkstatement", setState: "milkStatement" },
  { field: "loan_salaryslip", setState: "salarySlip" },
  { field: "loan_gst_certificate", setState: "gst" },
  { field: "loan_itr", setState: "itr" },
  { field: "balance_sheet_pandl", setState: "balanceSheetPandl" },
  { field: "loan_companyid", setState: "companyID" },
  { field: "loan_appoinment_letter", setState: "appointmentLetter" },
  {
    field: "loan_hr_confirmation_doc",
    setState: "hrConfirmationDoc",
  },
  { field: "loan_pf_letter", setState: "pfLetter" },
  { field: "office_electricity_bill", setState: "officeElectricityBill" },
  { field: "business_images", setState: "businessPhoto" },
  {
    field: "business_registration_proof",
    setState: "businessRegistrationProof",
  },
  { field: "company_firm_pan", setState: "companyFirmPan" },
  { field: "moa", setState: "moa" },
  { field: "aoa", setState: "aoa" },
  { field: "loan_shop_certificate", setState: "shopCertificate" },
  { field: "loan_gst_returns", setState: "gstReturns" },
  { field: "loan_udhyam", setState: "udhyam" },
  { field: "loan_partnership_deed", setState: "partnershipDeed" },
  {
    field: "loan_company_registration_certificate",
    setState: "companyRegistrationCertificate",
  },
  { field: "loan_mis_doc", setState: "miscDocs" },
];

const SectionThree = ({ openLoader, closeLoader, permissions }) => {
  const { borrowerData } = useBorrowerContext();
  const { loanid } = useParams();
  const [loanDetails, setLoanDetails] = useState(null);
  const borrowerDetails = borrowerData.borrower;

  const [docExist, setDocExist] = useState({
    pan: false,
    aadharFront: false,
    aadharBack: false,
    selfie: false,
    bankStatement: false,
    bankReport: false,
    companyID: false,
    appointmentLetter: false,
    gst: false,
    v: false,
    businessPhoto: false,
    electricityBill: false,
    currentAddressProof: false,
    drivingLicense: false,
    rationCard: false,
    voterID: false,
    passport: false,
    otherKyc: false,
    itr: false,
    milkStatement: false,
    otherIncomeDocs: false,
    salarySlip: false,
    shopCertificate: false,
    gumastadhara: false,
    udhyam: false,
    partnershipDeed: false,
    companyRegistrationCertificate: false,
    employeeID: false,
    hrConfirmationDoc: false,
    pfLetter: false,
    ePan: false,
    digiAadhar: false,
    aadhaeXml: false,
    rc: false,
    signVerification: false,
    gstReturns: false,
    eDL: false,
    selfPhoto: false,
    balanceSheetPandl: false,
    bankPassbookPhoto: false,
    officeElectricityBill: false,
    businessImages: false,
    businessRegistrationProof: false,
    companyFirmPan: false,
    moa: false,
    aoa: false,
  });

  const [borrowerDocModal, setBorrowerDocModal] = useState(false);
  const [docName, setDocName] = useState("");
  const [title, setTitle] = useState("");
  const [modalType, setModalType] = useState("");

  const [openOther, setOpenOther] = useState(false);
  const [openBasic, setOpenBasic] = useState(false);
  const [openCurrentAddress, setOpenCurrentAddress] = useState(false);
  const [openBank, setOpenBank] = useState(false);
  const [openIncome, setOpenIncome] = useState(false);
  const [openEmployement, setOpenEmployement] = useState(false);
  const [openBusiness, setOpenBusiness] = useState(false);

  useEffect(() => {
    const checkDocsExistance = () => {
      if (!borrowerData?.loan) return;

      const fetchedLoanDetails = borrowerData.loan;

      const foundLoan = fetchedLoanDetails.find(
        (item) => item.loan_id === loanid
      );

      if (!foundLoan) return;

      setLoanDetails(foundLoan);

      fieldsArr.forEach(({ field, setState }) => {
        const fieldValue = foundLoan[field];
        if (
          fieldValue &&
          (Array.isArray(fieldValue)
            ? fieldValue?.length !== 0
            : Object.keys(fieldValue).length !== 0)
        ) {
          setDocExist((prevState) => ({
            ...prevState,
            [setState]: true,
          }));
        }
      });
    };
    checkDocsExistance();
  }, [borrowerData, loanid]);

  const basicDocs = [
    {
      name: "Self Photo",
      exist: docExist.selfPhoto,
      apiName: "self_photo",
      modalType: "multi",
      isRequired: false,
    },
  ];

  const currentAddressDocs = [
    {
      name: "Electricity Bill",
      exist: docExist.electricityBill,
      apiName: "loan_electricity_bill",
      modalType: "multi",
      isRequired: false,
    },
    {
      name: "Ration Card",
      exist: docExist.rationCard,
      apiName: "ration_card",
      modalType: "multi",
      isRequired: false,
    },
  ];

  const bankDocs = [
    {
      name: "Bank Statement",
      exist: docExist.bankStatement,
      apiName: "loan_bank_statement",
      modalType: "multi",
      isRequired: false,
    },
    {
      name: "Bank Report Documents",
      exist: docExist.bankReport,
      apiName: "loan_bank_report_documents",
      modalType: "multi",
      isRequired: false,
    },
    {
      name: "Bank Signature Verification",
      exist: docExist.signVerification,
      apiName: "loan_signature_verification",
      modalType: "multi",
      isRequired: false,
    },
    {
      name: "Bank Passbook Photo",
      exist: docExist.bankPassbookPhoto,
      apiName: "bank_passbook_photo",
      modalType: "multi",
      isRequired: false,
    },
  ];

  const incomeDocs = [
    {
      name: "Milk Statement",
      exist: docExist.milkStatement,
      apiName: "loan_milkstatement",
      modalType: "multi",
      isRequired: false,
    },
    {
      name: "Salary Slip",
      exist: docExist.salarySlip,
      apiName: "loan_salaryslip",
      modalType: "multi",
      isRequired: false,
    },
    {
      name: "ITR",
      exist: docExist.itr,
      apiName: "loan_itr",
      modalType: "multi",
      isRequired: false,
    },
    {
      name: "GST Return",
      exist: docExist.gstReturns,
      apiName: "loan_gst_returns",
      modalType: "multi",
      isRequired: false,
    },
    {
      name: "Balance Sheet & P&L",
      exist: docExist.balanceSheetPandl,
      apiName: "balance_sheet_pandl",
      modalType: "multi",
      isRequired: false,
    },
  ];

  const employmentDocs = [
    {
      name: "Company ID",
      exist: docExist.companyID,
      apiName: "loan_companyid",
      modalType: "multi",
      isRequired: false,
    },
    {
      name: "Appointment Letter",
      exist: docExist.appointmentLetter,
      apiName: "loan_appoinment_letter",
      modalType: "multi",
      isRequired: false,
    },
    {
      name: "PF Letter",
      exist: docExist.pfLetter,
      apiName: "loan_pf_letter",
      modalType: "multi",
      isRequired: false,
    },
    {
      name: "HR Confirmation Letter",
      exist: docExist.hrConfirmationDoc,
      apiName: "loan_hr_confirmation_doc",
      modalType: "multi",
      isRequired: false,
    },
  ];

  const businessDocs = [
    {
      name: "Office Electricity Bill",
      exist: docExist.officeElectricityBill,
      apiName: "office_electricity_bill",
      modalType: "multi",
      isRequired: false,
    },
    {
      name: "Business Images",
      exist: docExist.businessPhoto,
      apiName: "business_images",
      modalType: "multi",
      isRequired: false,
    },
    {
      name: "Business Registration Proof",
      exist: docExist.businessRegistrationProof,
      apiName: "business_registration_proof",
      modalType: "multi",
      isRequired: false,
    },
    {
      name: "GST Certificate",
      exist: docExist.gst,
      apiName: "loan_gst_certificate",
      modalType: "multi",
      isRequired: false,
    },
    {
      name: "Shop & Establishment",
      exist: docExist.shopCertificate,
      apiName: "loan_shop_certificate",
      modalType: "multi",
      isRequired: false,
    },
    {
      name: "Udhyam",
      exist: docExist.udhyam,
      apiName: "loan_udhyam",
      modalType: "multi",
      isRequired: false,
    },
    {
      name: "Partnership Deed",
      exist: docExist.partnershipDeed,
      apiName: "loan_partnership_deed",
      modalType: "multi",
      isRequired: false,
    },
    {
      name: "Company / Firm PAN",
      exist: docExist.companyFirmPan,
      apiName: "company_firm_pan",
      modalType: "multi",
      isRequired: false,
    },
    {
      name: "Company Registration Certificate",
      exist: docExist.companyRegistrationCertificate,
      apiName: "loan_company_registration_certificate",
      modalType: "multi",
      isRequired: false,
    },
    {
      name: "MOA",
      exist: docExist.moa,
      apiName: "moa",
      modalType: "multi",
      isRequired: false,
    },
    {
      name: "AOA",
      exist: docExist.aoa,
      apiName: "aoa",
      modalType: "multi",
      isRequired: false,
    },
  ];

  const otherDocs = [
    {
      name: "Misc. Documents",
      exist: docExist.miscDocs,
      apiName: "loan_mis_doc",
      modalType: "multi",
      isRequired: false,
    },
  ];

  const viewBorrowerDocModal = (docName, title, modalType) => {
    setDocName(docName);
    setTitle(title);
    setModalType(modalType);
    setBorrowerDocModal(true);
  };

  const closeBorrowerDocModal = () => {
    setDocName("");
    setTitle("");
    setModalType("");
    setBorrowerDocModal(false);
  };

  const docDoesntExistHandler = () => {
    toast.error("Document does not exist");
  };

  const visibleBasicDocs = basicDocs.filter(
    (data) => data.isRequired || data.exist
  );

  const visibleCurrentAddressDocs = currentAddressDocs.filter(
    (data) => data.isRequired || data.exist
  );

  const visibleBankDocs = bankDocs.filter((d) => d.isRequired || d.exist);

  const visibleIncomeDocs = incomeDocs.filter((d) => d.isRequired || d.exist);

  const visibleEmploymentDocs = employmentDocs.filter(
    (d) => d.isRequired || d.exist
  );

  const visibleBusinessDocs = businessDocs.filter(
    (d) => d.isRequired || d.exist
  );

  const visibleOtherDocs = otherDocs.filter(
    (data) => data.isRequired || data.exist
  );

  console.log(permissions);

  return (
    <>
      {borrowerDocModal && (
        <ViewLoanDoc
          loanDetails={loanDetails}
          docName={docName}
          title={title}
          closeModal={closeBorrowerDocModal}
          openLoader={openLoader}
          closeLoader={closeLoader}
          modalType={modalType}
          isDownload={permissions.download_loan_application_document}
          isDelete={permissions.delete_loan_application_document}
        />
      )}

      <div className={styles.sectionThree}>
        <div className={styles.sectionThreeContainer}>
          {visibleBasicDocs.length > 0 && (
            <div className={styles.otherDocuments}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  color: "#034ea1",
                  fontWeight: "500",
                  marginBottom: ".5rem",
                  fontSize: "1.1rem",
                }}
                onClick={() => setOpenBasic(!openBasic)}
              >
                <span>Basic Documents</span>
                {openBasic ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </div>

              {openBasic && (
                <>
                  {visibleBasicDocs.map((data) => (
                    <div
                      key={data.apiName}
                      style={{
                        color: "gray",
                        fontSize: "0.9rem",
                        marginBottom: ".3rem",
                      }}
                    >
                      <span style={{ color: data.exist ? "green" : "red" }}>
                        {"> "}
                        {data.name}
                      </span>

                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: ".4rem",
                          float: "right",
                        }}
                      >
                        <AiOutlineEye
                          cursor="pointer"
                          onClick={() =>
                            data.exist
                              ? viewBorrowerDocModal(
                                  data.apiName,
                                  data.name,
                                  data.modalType
                                )
                              : docDoesntExistHandler()
                          }
                        />

                        {permissions.add_loan_application_document && (
                          <Link
                            to={`/edit/new/loan/${loanid}`}
                            state={borrowerDetails}
                          >
                            <BiEdit
                              style={{ marginLeft: ".3rem", color: "#949494" }}
                              cursor="pointer"
                            />
                          </Link>
                        )}
                      </span>
                    </div>
                  ))}
                </>
              )}
            </div>
          )}

          {visibleCurrentAddressDocs.length > 0 && (
            <>
              <hr
                style={{
                  backgroundColor: "gray",
                  margin: "1rem",
                  width: "100%",
                }}
              />
              <div className={styles.otherDocuments}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    color: "#034ea1",
                    fontWeight: "500",
                    marginBottom: ".5rem",
                    fontSize: "1.1rem",
                  }}
                  onClick={() => setOpenCurrentAddress(!openCurrentAddress)}
                >
                  <span>Current Address Documents</span>
                  {openCurrentAddress ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>

                {openCurrentAddress && (
                  <>
                    {visibleCurrentAddressDocs.map((data) => (
                      <div
                        key={data.apiName}
                        style={{
                          color: "gray",
                          fontSize: "0.9rem",
                          marginBottom: ".3rem",
                        }}
                      >
                        <span style={{ color: data.exist ? "green" : "red" }}>
                          {"> "}
                          {data.name}
                        </span>

                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: ".4rem",
                            float: "right",
                          }}
                        >
                          <AiOutlineEye
                            cursor="pointer"
                            onClick={() =>
                              data.exist
                                ? viewBorrowerDocModal(
                                    data.apiName,
                                    data.name,
                                    data.modalType
                                  )
                                : docDoesntExistHandler()
                            }
                          />

                          {permissions.add_loan_application_document && (
                            <Link
                              to={`/edit/new/loan/${loanid}`}
                              state={borrowerDetails}
                            >
                              <BiEdit
                                style={{
                                  marginLeft: ".3rem",
                                  color: "#949494",
                                }}
                                cursor="pointer"
                              />
                            </Link>
                          )}
                        </span>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </>
          )}

          {visibleBankDocs.length > 0 && (
            <>
              <hr
                style={{
                  backgroundColor: "gray",
                  margin: "1rem",
                  width: "100%",
                }}
              />
              <div className={styles.otherDocuments}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    color: "#034ea1",
                    fontWeight: "500",
                    marginBottom: ".5rem",
                    fontSize: "1.1rem",
                  }}
                  onClick={() => setOpenBank(!openBank)}
                >
                  <span>Bank Documents</span>
                  {openBank ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>

                {openBank && (
                  <>
                    {visibleBankDocs.map((data) => (
                      <div
                        key={data.apiName}
                        style={{
                          color: "gray",
                          fontSize: "0.9rem",
                          marginBottom: ".3rem",
                        }}
                      >
                        <span style={{ color: data.exist ? "green" : "red" }}>
                          {"> "}
                          {data.name}
                        </span>

                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: ".4rem",
                            float: "right",
                          }}
                        >
                          <AiOutlineEye
                            cursor="pointer"
                            onClick={() =>
                              data.exist
                                ? viewBorrowerDocModal(
                                    data.apiName,
                                    data.name,
                                    data.modalType
                                  )
                                : docDoesntExistHandler()
                            }
                          />

                          {permissions.add_loan_application_document && (
                            <Link
                              to={`/edit/new/loan/${loanid}`}
                              state={borrowerDetails}
                            >
                              <BiEdit
                                style={{
                                  marginLeft: ".3rem",
                                  color: "#949494",
                                }}
                                cursor="pointer"
                              />
                            </Link>
                          )}
                        </span>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </>
          )}

          {visibleIncomeDocs.length > 0 && (
            <>
              <hr
                style={{
                  backgroundColor: "gray",
                  margin: "1rem",
                  width: "100%",
                }}
              />
              <div className={styles.otherDocuments}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    color: "#034ea1",
                    fontWeight: "500",
                    marginBottom: ".5rem",
                    fontSize: "1.1rem",
                  }}
                  onClick={() => setOpenIncome(!openIncome)}
                >
                  <span>Income Documents</span>
                  {openIncome ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>

                {openIncome && (
                  <>
                    {visibleIncomeDocs.map((data) => (
                      <div
                        key={data.apiName}
                        style={{
                          color: "gray",
                          fontSize: "0.9rem",
                          marginBottom: ".3rem",
                        }}
                      >
                        <span style={{ color: data.exist ? "green" : "red" }}>
                          {"> "}
                          {data.name}
                        </span>

                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: ".4rem",
                            float: "right",
                          }}
                        >
                          <AiOutlineEye
                            cursor="pointer"
                            onClick={() =>
                              data.exist
                                ? viewBorrowerDocModal(
                                    data.apiName,
                                    data.name,
                                    data.modalType
                                  )
                                : docDoesntExistHandler()
                            }
                          />

                          {permissions.add_loan_application_document && (
                            <Link
                              to={`/edit/new/loan/${loanid}`}
                              state={borrowerDetails}
                            >
                              <BiEdit
                                style={{
                                  marginLeft: ".3rem",
                                  color: "#949494",
                                }}
                                cursor="pointer"
                              />
                            </Link>
                          )}
                        </span>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </>
          )}

          {visibleEmploymentDocs.length > 0 && (
            <>
              <hr
                style={{
                  backgroundColor: "gray",
                  margin: "1rem",
                  width: "100%",
                }}
              />
              <div className={styles.otherDocuments}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    color: "#034ea1",
                    fontWeight: "500",
                    marginBottom: ".5rem",
                    fontSize: "1.1rem",
                  }}
                  onClick={() => setOpenEmployement(!openEmployement)}
                >
                  <span>Employment Documents</span>
                  {openEmployement ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>

                {openEmployement && (
                  <>
                    {visibleEmploymentDocs.map((data) => (
                      <div
                        key={data.apiName}
                        style={{
                          color: "gray",
                          fontSize: "0.9rem",
                          marginBottom: ".3rem",
                        }}
                      >
                        <span style={{ color: data.exist ? "green" : "red" }}>
                          {"> "}
                          {data.name}
                        </span>

                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: ".4rem",
                            float: "right",
                          }}
                        >
                          <AiOutlineEye
                            cursor="pointer"
                            onClick={() =>
                              data.exist
                                ? viewBorrowerDocModal(
                                    data.apiName,
                                    data.name,
                                    data.modalType
                                  )
                                : docDoesntExistHandler()
                            }
                          />

                          {permissions.add_loan_application_document && (
                            <Link
                              to={`/edit/new/loan/${loanid}`}
                              state={borrowerDetails}
                            >
                              <BiEdit
                                style={{
                                  marginLeft: ".3rem",
                                  color: "#949494",
                                }}
                                cursor="pointer"
                              />
                            </Link>
                          )}
                        </span>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </>
          )}

          {visibleBusinessDocs.length > 0 && (
            <>
              <hr
                style={{
                  backgroundColor: "gray",
                  margin: "1rem",
                  width: "100%",
                }}
              />
              <div className={styles.otherDocuments}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    color: "#034ea1",
                    fontWeight: "500",
                    marginBottom: ".5rem",
                    fontSize: "1.1rem",
                  }}
                  onClick={() => setOpenBusiness(!openBusiness)}
                >
                  <span>Business Documents</span>
                  {openBusiness ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>

                {openBusiness && (
                  <>
                    {visibleBusinessDocs.map((data) => (
                      <div
                        key={data.apiName}
                        style={{
                          color: "gray",
                          fontSize: "0.9rem",
                          marginBottom: ".3rem",
                        }}
                      >
                        <span style={{ color: data.exist ? "green" : "red" }}>
                          {"> "}
                          {data.name}
                        </span>

                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: ".4rem",
                            float: "right",
                          }}
                        >
                          <AiOutlineEye
                            cursor="pointer"
                            onClick={() =>
                              data.exist
                                ? viewBorrowerDocModal(
                                    data.apiName,
                                    data.name,
                                    data.modalType
                                  )
                                : docDoesntExistHandler()
                            }
                          />

                          {permissions.add_loan_application_document && (
                            <Link
                              to={`/edit/new/loan/${loanid}`}
                              state={borrowerDetails}
                            >
                              <BiEdit
                                style={{
                                  marginLeft: ".3rem",
                                  color: "#949494",
                                }}
                                cursor="pointer"
                              />
                            </Link>
                          )}
                        </span>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </>
          )}

          {visibleOtherDocs.length > 0 && (
            <>
              <hr
                style={{
                  backgroundColor: "gray",
                  margin: "1rem",
                  width: "100%",
                }}
              />
              <div className={styles.otherDocuments}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    color: "#034ea1",
                    fontWeight: "500",
                    marginBottom: ".5rem",
                    fontSize: "1.1rem",
                  }}
                  onClick={() => setOpenOther(!openOther)}
                >
                  <span>Other Documents</span>
                  {openOther ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>

                {openOther && (
                  <>
                    {visibleOtherDocs.map((data) => (
                      <div
                        key={data.apiName}
                        style={{
                          color: "gray",
                          fontSize: "0.9rem",
                          marginBottom: ".3rem",
                        }}
                      >
                        <span style={{ color: data.exist ? "green" : "red" }}>
                          {"> "}
                          {data.name}
                        </span>

                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: ".4rem",
                            float: "right",
                          }}
                        >
                          <AiOutlineEye
                            cursor="pointer"
                            onClick={() =>
                              data.exist
                                ? viewBorrowerDocModal(
                                    data.apiName,
                                    data.name,
                                    data.modalType
                                  )
                                : docDoesntExistHandler()
                            }
                          />

                          {permissions.add_loan_application_document && (
                            <Link
                              to={`/edit/new/loan/${loanid}`}
                              state={borrowerDetails}
                            >
                              <BiEdit
                                style={{
                                  marginLeft: ".3rem",
                                  color: "#949494",
                                }}
                                cursor="pointer"
                              />
                            </Link>
                          )}
                        </span>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SectionThree;
